// @ts-nocheck

import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { fetchOurServicesTable, fetchOurServices, fetchOurServiceById, addOurService, updateOurService, removeOurService } from "../../api/ourServicesApi";

// Async thunks for Our service operations

export const getOurServices = createAsyncThunk(
  "ourService/getOurServices",
  async ({ page, limit }: { page: number; limit: number }, { dispatch, rejectWithValue }) => {
    dispatch(resetStatus());

    try {
      return await fetchOurServicesTable(page, limit);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getOurServiceById = createAsyncThunk(
  "ourService/getOurServiceById",
  async (id: string, { dispatch, rejectWithValue }) => {
    dispatch(resetStatus());

    try {
      return await fetchOurServiceById(id);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const createOurService = createAsyncThunk(
  "ourService/createOurService",
  async (newOurService: { name: string; description: string; photo: string }, { dispatch, rejectWithValue }) => {
    dispatch(resetStatus());

    try {
      return await addOurService(newOurService);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const editOurService = createAsyncThunk(
  "ourService/editOurService",
  async ({ id, updatedOurService }: { id: string; updatedOurService: { name: string; description: string; photo?: string } }, { dispatch, rejectWithValue }) => {
    dispatch(resetStatus());

    try {
      return await updateOurService(id, updatedOurService);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteOurService = createAsyncThunk(
  "ourService/deleteOurService",
  async (id: string, { dispatch, rejectWithValue }) => {
    dispatch(resetStatus());

    try {
      return await removeOurService(id);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

// Our Service Slice

const ourServiceSlice = createSlice({
  name: "ourService",
  initialState: {
    ourServices: [] as any[], 
    ourService: null as any | null,
    status: null as boolean | null,
    msg: "",
    error: null as string | null,
  },
  reducers: {
    resetStatus(state) {
      state.status = null;
      state.msg = "";
    },
  },
  extraReducers: (builder) => {
    builder
      // Get all Our services
      .addCase(getOurServices.fulfilled, (state, action: PayloadAction<any[]>) => {
        state.status = true;
        state.ourServices = action.payload;
      })
      .addCase(getOurServices.rejected, (state, action) => {
        state.status = false;
        state.error = action.payload as string;
      })
      
      // Get Our service by ID
      .addCase(getOurServiceById.fulfilled, (state, action: PayloadAction<any>) => {
        state.status = true;
        state.ourService = action.payload;
      })
      .addCase(getOurServiceById.rejected, (state, action) => {
        state.status = false;
        state.error = action.payload as string;
      })
      
      // Create Our service
      .addCase(createOurService.fulfilled, (state, action: PayloadAction<any>) => {
        if (Array.isArray(action.payload)) {
          state.ourServices.push(action.payload);
          state.status = true;
          state.msg = "Our service created successfully.";
        } else {
          console.log('Our service not an array');
        }
      })
      
      // Edit Our service
      .addCase(editOurService.fulfilled, (state, action: PayloadAction<any>) => {
        const { id, data } = action.payload;
        if (Array.isArray(state.ourServices)) {
          const index = state.ourServices.findIndex((service) => service.id === id);
          if (index !== -1) {
            state.ourServices[index] = data;
          }
          state.status = true;
          state.msg = "Our service updated successfully.";
        } else {
          console.log('Our service not an array');
        }
      })
      
      // Delete Our service
      .addCase(deleteOurService.fulfilled, (state, action: PayloadAction<string>) => {
        if (Array.isArray(state.ourServices)) {
          state.ourServices = state.ourServices.filter((service) => service.id !== action.payload);
          state.status = true;
          state.msg = "Our service deleted successfully.";
        } else {
          console.log('Our service not an array');
        }
      });
  },
});

export const { resetStatus } = ourServiceSlice.actions;
export default ourServiceSlice.reducer;
